export default __webpack_public_path__ + "static/media/a3.f2fdc103.png";